export const candiedFruit = {
  id: "candiedFruit",
  link: "/#/recipes/recipes/candiedFruit",
  name: "Candied Fruit Skewers",
  cuisine: "Alethi",
  summary: "Fruit in a crunchy clear sugar shell",
  inspiration: "Tanghulu",
  quantity: "8 skewers",
  time: "1 hour",
  notes:
    "You can use whatever type of fruit you like for this recipe. The fruit that Shallan ate would likely be similar to a plum, so I've included that here along with other fruit that went well, namely kiwifruit and persimmons. I decided to do larger skewers, though you could do individual pieces of fruit on toothpicks.",
  quotes:
    "They looked juicy and red, and had been stabbed through with a little stick before being dipped in a glassy melted sugar.",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/candied-fruit-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "kiwi",
          display: "3 kiwifruit"
        },
        {
          item: "persimmons",
          display: "1 fuyu persimmon"
        },
        {
          item: "plum",
          display: "1 plum"
        },
        {
          item: "sugar",
          display: "2 cups granulated sugar"
        },
        {
          item: "water",
          display: "1/4 cup water"
        },
        {
          item: "corn",
          display: "1/4 cup corn syrup"
        },
        {
          item: "honey",
          display: "2 tbsp honey"
        }
      ]
    }
  ],
  steps: [
    "Soak 8 bamboo skewers in warm water for at least 30 minutes. For all fruit, riper fruits will be easier to skewer.",
    "Peel the kiwifruit and slice into 1/2 inch thick rounds. Peel the persimmon, remove the stem and the white bit at the center, then slice into semi-circle slices, like cutting an apple. The slices should be about 1/2 inch thick at the thickest section. Cut the plum in half, remove the pit, then slice the same way as the persimmon. You do not need to peel the plum.",
    "Skewer the fruit, pushing the skewer the long way through each slice, in through the edge. If the fruit breaks as you're skewering it, feel free to skewer just through the middle of the slice. It just won't hold to the skewer as well that way.",
    "Line a baking sheet with wax paper. In a saucepan, combine the sugar, water, corn syrup, and honey.",
    "Bring to a boil over high heat, then reduce to medium and simmer until the mixture reads 300 degrees Fahrenheit on a candy or instant read thermometer. Remove from heat.",
    "Working very quickly to coat all skewers before the syrup cools, hold 1 skewer at a time over the pot. Spoon syrup over the skewered fruit, pouring and rotating to cover the fruit. Once covered, place on the paper-lined tray and coat the next skewer. Repeat until you've completed all of them.",
    "Let coated fruit skewers cool until sugar coating hardens. Eat within an hour or two, or refrigerate."
  ]
}
